import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const ISNULL = () => {
  return (
    <CardSection id="ISNULL" title="ISNULL">
      <Paragraph>
        지정된 열 내에 공백이나 null 값이 있는지 확인합니다. 공백 또는 null 값이
        발견되면 <b>TRUE</b> 값이 반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ISNULL(ARGUMENT)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 확인할 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ISNULL(`COLUMN`)</Paragraph>
        <Img src="computeIsNull" />
      </ListSection>
    </CardSection>
  );
};
